import { type CompanyTypeEnum, CompanyTypeEnum as CompanyTypeValues } from 'api';

const ValuesEnum = CompanyTypeValues || {
  BROKE: 'BROKE',
  EXCLUSIVE_REPRESENTATIVE: 'EXCLUSIVE_REPRESENTATIVE',
  MRF: 'MRF',
  MT_RE: 'MT_RE',
  MT_SMELT: 'MT_SMELT',
  MT_YD: 'MT_YD',
  OTHER: 'OTHER',
  PL_RE: 'PL_RE',
  PMERC: 'PMERC',
  PMILL: 'PMILL',
  PRF: 'PRF',
  P_MRF: 'P_MRF',
};

export const formatCompanyType = (companyType: CompanyTypeEnum) => {
  switch (companyType) {
    case ValuesEnum.MRF:
      return 'Material recovery facility';
    case ValuesEnum.PRF:
      return 'Plastic recovery facility';
    case ValuesEnum.PL_RE:
      return 'Plastic reprocessor';
    case ValuesEnum.MT_RE:
      return 'Metal reprocessor';
    case ValuesEnum.P_MRF:
      return 'Paper MRF';
    case ValuesEnum.PMILL:
      return 'Paper mill';
    case ValuesEnum.PMERC:
      return 'Paper merchant';
    case ValuesEnum.BROKE:
      return 'Broker';
    case ValuesEnum.MT_YD:
      return 'Metal Yard';
    case ValuesEnum.MT_SMELT:
      return 'Metal Smelter';
    default:
      return '';
  }
};
